import { render } from "./text-and-image.vue?vue&type=template&id=22a80eba"
import script from "./text-and-image.vue?vue&type=script&lang=js"
export * from "./text-and-image.vue?vue&type=script&lang=js"

import "./text-and-image.vue?vue&type=style&index=0&id=22a80eba&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__